import { PRIMITIVE_TYPE_OPTIONS, } from "../../model/index.js";
export const isPrimitivePropertyTypeJsonStruct = (propertyType) => {
    return (typeof propertyType === "object" &&
        "type" in propertyType &&
        PRIMITIVE_TYPE_OPTIONS.some((p) => propertyType.type === p));
};
export const isPrimitiveArrayPropertyTypeJsonStruct = (propertyType) => {
    return (typeof propertyType === "object" &&
        "type" in propertyType &&
        propertyType.type === "array" &&
        propertyType.items !== undefined);
};
export const isNodeLabelConstraintJsonStruct = (constraint) => {
    return constraint.entityType === "node" && constraint.nodeLabel !== undefined;
};
export const isRelationshipTypeConstraintJsonStruct = (constraint) => {
    return (constraint.entityType === "relationship" &&
        constraint.relationshipType !== undefined);
};
export const isNodeLabelIndexJsonStruct = (index) => {
    return index.nodeLabel !== undefined && index.indexType !== "lookup";
};
export const isRelationshipTypeIndexJsonStruct = (index) => {
    return index.relationshipType !== undefined && index.indexType !== "lookup";
};
export const isLookupIndexJsonStruct = (index) => {
    return index.indexType === "lookup";
};
//# sourceMappingURL=types.js.map